import * as React from 'react';
import { OptionGroup } from '@mui/base';
import { styled } from '@mui/system';

const StyledGroupOptions = styled('ul')`
  list-style: none;
  margin-left: 0;
  padding: 0;
  margin-top: 0px;
  margin-bottom: 5px;

  > li {
    padding-left: 20px;
  }
`;

const StyledGroupRoot = styled('li')`
  list-style: none;
`;

const StyledGroupHeader = styled('span')`
  display: block;
  padding: 15px 0 5px 10px;
  font-size: 0.75em;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  color: '#57606a';
`;

const CustomOptionsGroup = (props: any) => {
  const slots = {
    root: StyledGroupRoot,
    label: StyledGroupHeader,
    list: StyledGroupOptions,
    ...props.slots,
  };

  return <OptionGroup {...props} slots={slots} />;
};

export default CustomOptionsGroup;
